import { FunctionalLocation } from './functional-location.model';
import { Alarm } from './alarm.model';
import { PiPoint } from './pi-data.model';
import { WorkCenterLabel } from './work-center-label.model';
import { RuleMessage } from './rule-message.model';

export interface Rule {
  uid: string;
  context?: string;
  description: string;
  formula?: string;
  gain?: string;
  pythonRule: string;
  ownedBy: string;
  criticality: string;
  alertThreshold?: number;
  toleranceThreshold?: number;
  minAlertThreshold?: number;
  minToleranceThreshold?: number;
  ruleToPis: RuleToPi[];
  alarms?: Alarm[];
  ruleToPotentialCauses?: any[];
  state?: any;
  latestAlarm?: Alarm;
  latestMessage?: RuleMessage;
  periodInMinutes?: number;
  piPointsDataLookbackWindowInMinutes?: number;
  stage: Stage;
  isActive: boolean;
  isTracked?: boolean;
  lastErrorType?: string;
  lastErrorMessage?: string;
  lastEvaluationDateTime?: string;
  lastActivationConditionTrueDateTime?: string;
  weeksBeforeFailure?: number;
  activationConditionPiExpression?: string;
  activationConditionPythonExpression?: string;
  evaluationsAboveAlertThresholdRatio?: number;
  evaluationsAboveToleranceThresholdRatio?: number;
  evaluationsBelowMinAlertThresholdRatio?: number;
  evaluationsBelowMinToleranceThresholdRatio?: number;
  behaviorSummary?: string;
  functionalLocationId?: string | null;
  functionalLocation?: FunctionalLocation | null;
  evaluationsToConsiderForAlarm?: number | null;
  minEvaluationsToTriggerAlarm?: number | null;
  piPointInterpolationIntervalInMinutes?: number | null;
  workCenterLabels?: WorkCenterLabel[];
}

export interface RuleToPi {
  piPointFK: string;
  ruleFK: string;
  piPoint?: PiPoint;
  rule?: Rule;
}

export enum Stage {
  Dev = 0,
  Qa = 1,
  ProdManual = 2,
  ProdAutomated = 3,
}
